import { IDefineCommand } from 'core-ts-types';

angular
  .module('major-explorer-data')
  .service(
    'loadRelatedCareersCommand',
    ($http: ng.IHttpService, defineCommand: IDefineCommand, RelatedCareersBuilder: any) => {
      return defineCommand('loadRelatedCareersCommand', (deferred: ng.IDeferred<any>, programId: string) => {
        $http
          .get(`programpicker/program/${programId}/careers/`)
          .then(({ data }) => {
            deferred.resolve(new RelatedCareersBuilder(data));
          })
          .catch((reason) => {
            deferred.reject(reason);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/load_related_careers_command.ts